// import { NgxMatFileInputModule } from '@angular-material-components/file-input';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { ImageViewerDirective } from 'src/app/core/directives/image-viewer.directive';
import { TranslationModule } from 'src/app/i18n';
import { ShareModule } from '../../share.module';

@Component({
  selector: 'image-uploader',
  templateUrl: './image-uploader.component.html',
  imports: [CommonModule, ShareModule, TranslationModule, ImageViewerDirective],
})
export class ImageUploaderComponent {
  //#region Properties
  imageUploaderCount: number = 1;
  imageHasError: boolean = false;

  @Input() imageLoading: boolean = false;
  @Input() imageSrc: string;
  @Input() imageUploaderTitle: string;
  @Input() isShowAddBtn: boolean = false;
  @Input() isDisableAddBtn: boolean = false;
  @Input() returnFile: boolean = false;
  @Input() imageUploaderSize: string = 'tw-h-48 tw-w-48';

  @Output('imgSrc') output_imgSrc = new EventEmitter<string>();
  @Output('imageUploaderCount') output_imageUploaderCount =
    new EventEmitter<number>();
  @Output() isClickOnAddBtn = new EventEmitter<boolean>();
  @Output() isClickOnDeleteBtn = new EventEmitter<boolean>();
  //#endregion

  //#region upload image

  onCheckFile(event) {
    this.imageLoading = true;
    const file = event?.target?.files[0];
    if (!file) return;

    this.imageSrc = file;

    if (this.returnFile) {
      this.output_imgSrc.emit(this.imageSrc);
      return;
    }

    this.getFile(file);
  }

  getFile(file) {
    if (!file) {
      this.imageSrc = '';
      return;
    }
    this.imageSrc = file;

    this.onFileChanged(file);
  }

  onFileChanged(file: any) {
    if (file) {
      const reader = new FileReader();

      if (
        file.type == 'image/png' ||
        file.type == 'image/jpeg' ||
        file.type == 'image/jpg' ||
        file.type == 'image/svg+xml'
      )
        reader.onload = (event: any) => {
          this.imageSrc = event.target.result;
          if (this.imageSrc) {
            this.imageLoading = false;
            this.output_imgSrc.emit(this.imageSrc);
          }
        };
      reader.readAsDataURL(file);
    }
  }
  //#endregion

  deleteImage() {
    this.imageSrc = '';
    this.imageHasError = false;
    this.output_imgSrc.emit();
    this.isClickOnDeleteBtn.emit();
  }

  addNewImageUploaderField() {
    if (this.isDisableAddBtn) return;
    this.isClickOnAddBtn.emit();
  }

  setDefaultImage(event: Event) {
    this.imageHasError = true;
    (event.target as HTMLImageElement).src =
      '/assets/media/svg/icons/image-x-svgrepo-com.svg';
  }
}
